import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=0d485f8c&scoped=true"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=0d485f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d485f8c",
  null
  
)

export default component.exports